import { gql } from '@apollo/client';

const CATEGORY_RECOMMENDATIONS_QUERY = gql`
  query CATEGORY_RECOMMENDATIONS_QUERY($placements: [String]!, $hasUserConsent: Boolean!, $hideSwatches: Boolean) {
    categoryRecommendations(placements: $placements, hasUserConsent: $hasUserConsent, hideSwatches: $hideSwatches) {
      placements {
        id
        name
        title
        products {
          swatches {
            id
            imageUrl
            name
            productId
            productImageUrl
            productUrl
            sequence
          }
          swatchList {
            id
            name
            product {
              id
              imageSet {
                primaryFaceOutImage
              }
            }
            sequence
            swatchImage
          }
          imageUrl
          price
          badges {
            text
            theme
          }
          collection
          defaultSwatchSequence
          departmentName
          id
          imageSet {
            lifestyleImage
            modelImage
            primaryFaceOutImage
            primaryHoverImage
            prodImage
          }
          kic
          memberPriceObject {
            description
            discountPrice
            discountText
            originalPrice
            variant
          }
          name
          partNumber
          priceObject {
            description
            discountPrice
            discountText
            originalPrice
            variant
          }
          productPageUrl
          promoMessaging {
            message
            type
          }
          shortDescriptors
        }
        treatments {
          control
          testId
          testType
          treatmentId
          treatmentName
        }
      }
      mvtDetailed {
        control
        eligible
        testId
        treatmentId
        treatmentName
      }
      rcs
      userId
      algonomyDebug
    }
  }
`;

export const RECOMMENDATIONS_CONFIG_QUERY = gql`
  query RECOMMENDATIONS_CONFIG_QUERY {
    config {
      recommendationsHideSwatchesMasterFlag: genericType(name: "recommendationsHideSwatchesMasterFlag")
      enableSecondRecommendationsContainerOnHomePage: genericType(name: "enableSecondRecommendationsContainerOnHomePage")
    }
  }
`;

export default CATEGORY_RECOMMENDATIONS_QUERY;
